import { Component, ViewEncapsulation, ChangeDetectionStrategy, HostBinding, Input } from '@angular/core';
import { BaseDirective } from '../../base.directive';

@Component({
    selector: 'eui-search',
    templateUrl: './search.component.html',
    styleUrls: ['./_styles/_index.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.None,
})

export class EuiSearchComponent extends BaseDirective {
    @HostBinding('class')
    get cssClasses() {
        return [
            super.getCssClasses('eui-search'),
        ].join(' ').trim();
    }

    isActive = false;

    constructor(
    ) {
        super();
    }

    onSearchClicked(event: any) {
        this.isActive = !this.isActive;
    }

    onToggle(event: any) {
        this.isActive = !this.isActive;
    }

    onBackClicked(event: any) {
        this.isActive = !this.isActive;
    }
}
